import metrics from 'maps/metrics';

export interface ITableHeader {
  label: string;
  value: string;
  type?: string;
  key: string;
}

export function getMenuItems(
  heads: ITableHeader[],
  hasOwnerName = true,
  priorityFilter = false,
  isPositionTopSort = false
): any {
  const menuItems: any = {};

  heads.forEach((head: ITableHeader) => {
    if (
      head.key === 'displayName' ||
      head.key === 'customerId' ||
      head.key === 'activity'
    ) {
      menuItems[head.key] = [];
      if (head.key === 'displayName' && priorityFilter) {
        // Priority
        menuItems[head.key] = [
          ...menuItems[head.key],
          {
            label: 'Priority Only',
            sortMetric: 'priorityOnly',
            sortOrder: 'asc',
          },
        ];
      }
      menuItems[head.key] = [
        ...menuItems[head.key],
        {
          label: `${head.label} (A-Z)`,
          sortMetric: head.key,
          sortOrder: 'asc',
        },
        {
          label: `${head.label} (Z-A)`,
          sortMetric: head.key,
          sortOrder: 'desc',
        },
      ];

      if (head.key === 'displayName' && hasOwnerName) {
        menuItems[head.key] = [
          ...menuItems[head.key],
          {
            label: `${metrics.ownerDisplayName.label} (A-Z)`,
            sortMetric: metrics.ownerDisplayName.key,
            sortOrder: 'asc',
          },
          {
            label: `${metrics.ownerDisplayName.label} (Z-A)`,
            sortMetric: metrics.ownerDisplayName.key,
            sortOrder: 'desc',
          },
        ];
      }
    } else if (head.key === 'lastUpdated') {
      menuItems[head.key] = [
        {
          label: 'New To Old',
          sortMetric: head.key,
          sortOrder: 'desc',
        },
        {
          label: 'Old To New',
          sortMetric: head.key,
          sortOrder: 'asc',
        },
      ];
    } else if (isPositionTopSort) {
      menuItems[head.key] = [
        {
          label: 'High to Low',
          sortMetric: head.key,
          sortOrder: 'desc',
        },
        {
          label: 'Low to High',
          sortMetric: head.key,
          sortOrder: 'asc',
        },
      ];
    } else {
      menuItems[head.key] = [
        {
          label: 'High to Low',
          sortMetric: head.key,
          sortOrder: 'desc',
        },
        {
          label: 'Low to High',
          sortMetric: head.key,
          sortOrder: 'asc',
        },
      ];
    }
  });

  return menuItems;
}
